export default __webpack_public_path__ + "static/hram-ikony-bozhiej-materi-utoli-moya-pechali-g-saratov-obshchij-vid-3b3a0ebbf84fe9fa75a0ea46de3e1443.jpg";